import { LICENSE_COUNTDOWN_SUCCESS, LICENSE_COUNTDOWN_ERROR} from '../../actions/Firebase/getExpiryCountdownAction';
import { FIREBASE_LICENSE_SUCCESS, FIREBASE_LICENSE_ERROR, LICENSE_CHECKED, LICENSE_CHECKING } from '../../actions/Firebase/getFirebaseLicenseAction';
import { setLicense } from "../../../functions/userIdentity/setLicense";
import _ from 'lodash';

const initialState = {
    error: null,
    countdown: 100,
    licenseValid: true,
    licenseChecked: false,
    licenseChecking: false
};

const licenseReducer = (state = initialState, action) => {
    switch (action.type) {
        //Expiry Countdown Reducer
        case LICENSE_COUNTDOWN_SUCCESS:
            return {
                ...state,
                countdown: action.payload,
            };
        case LICENSE_COUNTDOWN_ERROR:
            return {
                ...state,
                error: action.payload,
            };

        //Firebase License File Reducer 

        case FIREBASE_LICENSE_SUCCESS:
            // License is already saved in the action before this dispatch
            return {
                ...state,
                licenseValid: action.payload,
                error: null // Clear errors on successful license validation
            };
        case FIREBASE_LICENSE_ERROR:
            // License is already saved in the action before this dispatch
            return {
                ...state,
                licenseValid: false,
                error: action.payload?.error || action.payload?.message || 'License validation failed'
            };
        case LICENSE_CHECKED:
            return {
                ...state,
                licenseChecked: true,
                licenseChecking: false,
                error: null // Clear any previous errors when check completes
            };
        case LICENSE_CHECKING:
            return {
                ...state,
                licenseChecking: true,
                error: null // Clear errors when starting a new check
            };

        default:
            return state;
    }

};

export default licenseReducer;
